import styled from '@emotion/styled'

export const FormWithoutStyles = styled.form`
  display: contents;
`
